import ChargeTransactionDetailView from 'features/Charge/ChargeTransaction/components/ChargeTransactionDetailView';
import UIHelper from 'general/helpers/UIHelper';
import useRouter from 'hooks/useRouter';

function ChargeTransactionDetailScreen(props) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const chargeTransactionId = router.query?.chargeTransactionId;

  return (
    <div>
      {/* breadcrumb */}
      <div>
        {UIHelper.buildBreadcrumb([
          {
            title: 'Danh sách phiên sạc',
            onPress: () => {
              router.navigate(-1);
            },
          },
          { title: 'Chi tiết phiên sạc' },
        ])}
      </div>
      <div className="mt-4">
        <ChargeTransactionDetailView chargeTransactionId={chargeTransactionId} />
      </div>
    </div>
  );
}

export default ChargeTransactionDetailScreen;
